import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ProfileUpload } from '../../app-routing.module';
import { AppComponentClass } from '../../shared/service/AppComponent.class';
import { Theme } from '../../shared/service/AutoTheme';
import { Panelconfig, PanelconfigForm } from '../model/model.class';
import { PanelconfigService, ProfileService } from '../profile.service';

@Component({
  selector: 'app-panel-config',
  templateUrl: './panel-config.component.html',
  styleUrls: ['./panel-config.component.css']
})


export class PanelConfigComponent extends AppComponentClass<Panelconfig, PanelconfigForm>{
  panelForm: FormGroup
  // public profileres
  public Profilepanel = ProfileUpload + '/Profilepanel';
  panel_logo: string;
  constructor(protected theme: Theme, protected data: PanelconfigService, protected router: Router, protected fb: FormBuilder, protected msg: MatSnackBar) {
    super(data, router, fb, msg);
  }

  ngOnInit() {
    this.cdata = new PanelconfigForm(null);
    this.panelForm = this.cdata.makeform(this.fb)
    this.data.getService("main").subscribe(res => {
      console.log(res)
      this.panel_logo = res[0].logo;
      sessionStorage.setItem("panel_logo", this.panel_logo)
      this.cdata = new PanelconfigForm(res[0])
      this.panelForm = this.cdata.makeform(this.fb)
    }, err => {
      this.cdata = new PanelconfigForm(null);
      this.panelForm = this.cdata.makeform(this.fb)
    })
  }

  AddRecord(): any {
    //this.record.push(this.panelForm.value)
    this.data.savepanel(this.panelForm.value).subscribe(res => {
      console.log(res)
      this.openSnackBar("Panel Configuration Update successfully", "clear");
      this.ngOnInit()
    })
  }

  onCompletes(event: any) {
    console.log(event);
    sessionStorage.setItem("panel_logo", event.filename);
    this.openSnackBar("Panel Logo uploaded successfully", "clear");
    this.panel_logo = sessionStorage.getItem("panel_logo");
  }
}
